<template>
  <fieldset class="border rounded m-2 px-2 pt-2">
    <div class="flex items-center mx-1 mb-2">
      演講者
    </div>
    <!-- <div v-if="!readonly" class="flex items-center mx-1 mb-2">
      <button type="button" class="ml-auto" @click="table.insert">
        <FontAwesome icon="plus" class="w-5 h-5 text-yellow-500" />
      </button>
    </div> -->
    <vxe-form class="" ref="speakerForm" :data="table.formData" :rules="table.rules" titleAlign="right" @submit="table.save">
        <vxe-form-item title="姓名" field="SpeakerId" :item-render="{}" span="7">
          <template #default="{ data }">
            <select-box v-bind="userSelectorOptions" v-model="data.SpeakerId" />
          </template>
        </vxe-form-item>
        <vxe-form-item title="類型" field="Type" :item-render="{}" span="7">
          <template #default="{ data }">
            <vxe-select v-model="data.Type" placeholder="請選擇類型" clearable>
              <vxe-option v-for="(item) in Object.values($enums.SpeakerType)" :key="'pay-status-' + item.Value" :value="item.Value" :label="item.Name"></vxe-option>
            </vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="排序" field="Ordinal" :item-render="{}" span="7">
          <template #default="{ data }">
            <vxe-input type="number" v-model="data.Ordinal" placeholder="請輸入排序" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item :item-render="{}" span="3">
          <template #default>
            <vxe-button type="submit" status="primary" content="確認">
            </vxe-button>
          </template>
        </vxe-form-item>
    </vxe-form>
    <vxe-table class="mb-2" ref="grid" :data="table.data" v-bind="gridOptions.props">
      <vxe-column field="Name" title="姓名">
      <template #default="{ row }">
        <span v-if="row.Speaker">{{ row.Speaker.Name }}</span>
        <span v-else>{{ row.Name }}</span>
      </template>
      </vxe-column>
      <vxe-column field="Type" title="類型" :formatter="({ cellValue }) => Object.values($enums.SpeakerType).find(e => e.Value === cellValue)?.Name">
      </vxe-column>
      <vxe-column field="Ordinal" title="排序" sortable>
      </vxe-column>
      <vxe-column v-if="!readonly" title="操作" width="150">
        <template #default="{ row }">
          <div class="flex justify-content">
            <!-- <vxe-button @click="table.update(row)">編輯</vxe-button> -->
            <vxe-button @click="table.delete(row)">刪除</vxe-button>
          </div>
        </template>
      </vxe-column>
    </vxe-table>
    <!-- <vxe-modal v-model="table.isEditing" :title="table.selectedRow ? '編輯演講人' : '新增演講人'" width="70%" min-width="600"
      height="400" :loading="table.isLoading" resize destroy-on-close showFooter>
      <template #default>
        <vxe-form ref="form" :data="table.formData" titleAlign="right" @submit="table.save">
           <vxe-form-item title="是否為外部作者" field="OutSource" :item-render="{}" span="24" titleWidth="150">
            <template #default="{ data }">
              <vxe-checkbox v-model="data.OutSource" :checked-value="false" :unchecked-value="true" @change="evt => { if(evt.checked) { data.Name = null; } else { data.SpeakerId = null; } }"></vxe-checkbox>
             </template>
          </vxe-form-item>
          <vxe-form-item title="姓名" field="Name" :item-render="{}" span="12">
            <template #default="{ data }">
              <vxe-input v-if="!data.OutSource" v-model="data.Name" placeholder="請輸入姓名" clearable></vxe-input>
              <select-box v-else v-bind="userSelectorOptions" v-model="data.SpeakerId" />
            </template>
          </vxe-form-item>
          <vxe-form-item title="撰稿費用" field="Fee" :item-render="{}" span="12">
            <template #default="{ data }">
              <vxe-input type="number" v-model="data.Fee" placeholder="請輸入撰稿費用" clearable></vxe-input>
             </template>
          </vxe-form-item>
          <vxe-form-item title="付款狀態" field="PayStatus" :item-render="{}" span="12">
            <template #default="{ data }">
              <vxe-select v-model="data.PayStatus" placeholder="請選擇付款狀態" clearable>
                <vxe-option v-for="(item) in Object.values($enums.PayStatus)" :key="'pay-status-' + item.Value" :value="item.Value" :label="item.Name"></vxe-option>
              </vxe-select>
             </template>
          </vxe-form-item>
          <vxe-form-item title="排序" field="Ordinal" :item-render="{}" span="12">
            <template #default="{ data }">
              <vxe-input type="number" v-model="data.Ordinal" placeholder="請輸入排序" clearable></vxe-input>
             </template>
          </vxe-form-item>
          <vxe-form-item title="外部來源" field="Source" :item-render="{}" span="24">
            <template #default="{ data }">
              <vxe-textarea v-model="data.Source" placeholder="請輸入外部來源" clearable></vxe-textarea>
             </template>
          </vxe-form-item>
       </vxe-form>
      </template>
      <template #footer>
        <vxe-button type="button" status="primary" content="確認"
          @click="$refs.form.validate((errMap) => { if (errMap === undefined) $refs.form.dispatchEvent('submit'); })">
        </vxe-button>
      </template>
    </vxe-modal> -->
  </fieldset>
</template>
<script lang="ts">
/* eslint-disable */
import SelectBox, { SelectBoxOptions } from "@/cloudfun/components/SelectBox.vue";
import CloudFun, { defineComponent, ref, reactive, PropType, Condition, Operator } from "@cloudfun/core";
import { watch } from "vue";
import { VxeTableProps } from "vxe-table";

interface Speaker {
  Name?: string;
  SpeakerId?: string;
  Speaker?: { Id: string, Name: string, Photo: any };
  Type: number;
  Ordinal: number;
  AgendaId: number;
}

export default defineComponent({
  name: "DocumentSpeakerTable",
  components: {
    SelectBox
  },
  props: {
    data: {
      type: Array as PropType<Speaker[]>,
      default: () => []
    },
    aid: Number,
    readonly: Boolean,
  },
  setup(props, { emit }) {
    const model = CloudFun.current?.model;
    const grid = ref<any>();
    const gridOptions = {
      props: {
        sortConfig: {
          defaultSort: { field: 'Ordinal', order: 'asc' }
        }
      } as VxeTableProps,
      insert() {
        const { row } = grid.value.insertAt({}, 0);
        grid.value.setActiveRow(row)
      }
    }

    const table = reactive({
      data: [] as Speaker[],
      isLoading: false,
      isEditing: false,
      formData: { Ordinal: 0 } as Speaker,
      selectedRow: null as Speaker | null,
      // insert() {
      //   table.formData = { OutSource: false, Fee: 0, PayStatus: 0, Ordinal: 0 };
      //   table.selectedRow = null;
      //   table.isEditing = true;
      // },
      update(row: Speaker) {
        table.formData = { ...row };
        table.selectedRow = row;
        table.isEditing = true;
      },
      delete(row: Speaker) {
        grid.value.remove(row);
      },
      async save() {
        if (table.formData.SpeakerId) {
          const temp = await model?.dispatch("speaker/find", table.formData.SpeakerId)
          table.formData.Speaker = { Id: temp.Id, Name: temp.Name, Photo: null };
          //table.formData.AgendaId = props.aid!;
        }

        await grid.value.insert(table.formData);
        grid.value.sort({ field: "Ordinal", order: 'asc' });

        //emit('refresh');
      },
      rules: {
        SpeakerId: [{ required: true }],
        Type: [{ required: true }],
        Ordinal: [{ required: true }],
      }
    })

    watch(() => props.data, async(value) => {
      console.log(value)
      const SpeakerIds = value.filter(e => e.SpeakerId).map(e => e.SpeakerId);
      const Speakers: Speaker['Speaker'][] = await model?.dispatch("speaker/query", { condition: new Condition("Id", Operator.In, SpeakerIds) });
      table.data = value.map(e => {
        if (e.SpeakerId) {
          const speaker = Speakers.find(a => a && a.Id === e.SpeakerId)
          if(speaker) e.Speaker = { Id: speaker!.Id, Name: speaker!.Name, Photo: null };
        } else {
        }
        return e;
      }).sort((a, b) => a.Ordinal - b.Ordinal);
    }, { immediate: true });

    const speakerForm = ref<any>();

    const userSelectorOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "選擇",
      textField: "Name",
      valueField: "Id",
      columns: [
        {
          field: "Name",
          title: "姓名",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        },
        {
          field: "Company",
          title: "公司名稱",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        },
        {
          field: "Department",
          title: "部門名稱",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        },
        {
          field: "Position",
          title: "職稱",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        }
      ],
      showHeader: true,
      promises: {
        find: value => model!.dispatch("speaker/find", value), // eslint-disable-line
        query: params => model!.dispatch("speaker/query", params) // eslint-disable-line
      }
    };
    return {
      table,
      grid,
      gridOptions,
      speakerForm,
      userSelectorOptions
    }
  },
  methods: {
    getData() {
      return this.grid.getTableData().fullData;
    }
  }
})
</script>
